import React, { useEffect, useRef } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import moment from 'moment-timezone';
// 需搭配 typescript v3.8.3 且小於 v4.0.0，編譯才會正確
import Flicking from '@egjs/react-flicking';
import { Product } from 'bff/models/product';
import { Recommand } from 'bff/models/info/recommand';
import { InsType } from 'constants/enums/insType.enum';
import apiCommonService from 'bff/services/commonService';
import commonService from 'utils/commonService';
import ProgramBlock from 'components/ProgramBlock';
import { IProps } from './types';

const duration: number = 850;

const ProdKind02: React.FC<IProps> = (props) => {
  const titleRef = useRef<HTMLDivElement>(null);
  const flickingRef = React.createRef<Flicking>();

  /**
   * @description 設定檢視商品卡片個數至 css 全域變數: --slides-count
   */
  useEffect(() => {
    const root = document.documentElement;
    if (root && root.style) {
      root.style.setProperty('--slides-count', props.slidesPerView.toString());
    }
  }, [props.slidesPerView]);

  /**
   * @description 立即投保點選事件
   */
  const handleRedirect = async (product: Product) => {
    let _programId = '';
    // 如有填入專案代碼，判斷專案代碼是否存在
    if (props.programId) {
      const res = await apiCommonService.verifyProgramId(props.programId, product.INS_TYPE_ID);
      if (res && res.PROGRAM_ID) {
        _programId = res.PROGRAM_ID;
      }
    }
    const path = {
      pathname: `${product.FEE_EVAL_URL}`,
      state: {
        insTypeId: product.INS_TYPE_ID,
        prodId: product.PROD_ID,
        programId: _programId
      }
    };

    commonService.setActiveProdId(product.INS_TYPE_ID, product.PROD_ID, _programId);

    props.history.push(path);
  };

  /**
   * @description 產生商品 Elements
   */
  const createProducts = () => {
    if (!props.products || props.products.length === 0) return;

    const products = _.map(props.products, (product: Product, index: number) => {
      const recommands = props.recommands ? props.recommands.RECOMMAND : [];
      const recommandsFilter = recommands && recommands.length > 0 && recommands.filter((recommand: Recommand) => moment() < moment(recommand.END_DATE));
      const recommandData = recommandsFilter && recommandsFilter.length > 0 && recommandsFilter.find((recommand: Recommand) => recommand.PROD_ID === product.PROD_ID);

      return (
        <div className="panel-card" key={index}>
          {!recommandData ? (
            <div className="prod-kind__pds-block">
              <div className="prod-kind__pds-block-content">
                <div className="prod-kind__pds-block-title">
                  <span>{product.PROD_NAME}</span>
                  {(product.PROD_ID?.includes('APE') || product.PROD_ID?.includes('AME')) && <span>-電車版</span>}
                </div>
                {
                  product.CUSTOM_BRIEF
                    ? <div className="prod-kind__pds-block-desc">{commonService.htmlParser(product.CUSTOM_BRIEF)}</div>
                    : <div className="prod-kind__pds-block-desc">{product.BRIEF}</div>
                }
                {/* @egjs/react-flicking 內元素可直接綁定事件， circular 模式無渲染問題 */}
                <span id={`${product.PROD_ID}`} className="element__link prod-kind__pds-block-btn" onClick={() => handleRedirect(product)}>
                  {product.INS_TYPE_ID === InsType.Travel ? '立即試算/投保' : '試算/投保/續保'}
                </span>
              </div>
            </div>
          ) : (
            <ProgramBlock insTypeId={product.INS_TYPE_ID} content={recommandData} favoriteBtn={false} />
          )}
        </div>
      );
    });

    /**
     * @description 移動至上一個商品
     */
    const handlePrevClick = () => {
      if (flickingRef.current) {
        flickingRef.current.prev(duration);
      }
    };

    /**
     * @description 移動至下一個商品
     */
    const handleNextClick = () => {
      if (flickingRef.current) {
        flickingRef.current.next(duration);
      }
    };

    return (
      <div className="flicking-products">
        <div className="control-section">
          <button className={'slider__prev-btn' + (props.products.length <= props.slidesPerView ? ' hide' : '')} onClick={handlePrevClick} />
        </div>
        {/* 若小於三個商品，則關閉 loop 模式 (開啟 bound 模式) */}
        <Flicking
          ref={flickingRef}
          zIndex={0}
          duration={duration}
          circular={products.length > 3}
          bound={products.length <= 3}
          autoResize
          preventClickOnDrag
          onHoldEnd={() => {
            // 避免觸發不預期的鎖定功能，故拖曳後設定焦點於標題
            if (titleRef.current) titleRef.current.focus();
          }}
        >
          {products}
        </Flicking>
        <div className="control-section">
          <button className={'slider__next-btn' + (props.products.length <= props.slidesPerView ? ' hide' : '')} onClick={handleNextClick} />
        </div>
      </div>
    );
  };

  return (
    <div className="prod-kind" ref={props.refSetting}>
      <div className="template-container">
        <div className="template-content">
          <div className="prod-kind__title-section">
            <div ref={titleRef} className="prod-kind__title">商品種類</div>
          </div>
          <div className="prod-kind__slider-section">
            {createProducts()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default withRouter(ProdKind02);
